import React from 'react'
import BaseIcon from '../../BaseIcon'

export default class NetworkOfficeIcon extends BaseIcon {
  getChildren = () => [
    <path fill={ this.getColor() }
          d="M1665,743v-2h9v-2h-8v1.992h-0.01V725.011L1675,722v0.015l8,2.985v16h1v2h-19Zm1-6,8-.889v-2l-8,.889v2Zm0-4,8-1.778v-2L1666,731v2Zm0-4,8-2.667v-2L1666,727v2Zm13-3.5-3-1.125v2l3,1.125v-2Zm0,4.5-3-.75v2l3,0.75v-2Zm0,4.5-3-.375v2l3,0.375v-2Zm0,4.5h-3v2h3v-2Z"
          transform="translate(-1662.5 -720.5)"/>
  ]
  getViewBox = () => '0 0 24 24'
}


